import React, { useRef, useEffect, useState, useContext } from "react";

// ------------------ COMPONENTES DE PRIMEREACT--------------------------
import { Toast } from "primereact/toast";
import { InputText } from "primereact/inputtext";
import { InputNumber } from "primereact/inputnumber";
import { Button } from 'primereact/button';

// ------------------ COMPONENTES DE BASE--------------------------
import { useForm } from "../../../../../../Base/Hooks/useForm";
import { toastShow } from "../../../../../../Base/Services/ToastService";
import Loader from "../../../../../../Base/Components/Loader/Loader";
import Card from "../../../../../../Base/Components/Card/Card";
import { AuthContext } from "../../../../../../Base/Context/AuthContext/AuthContext";

// ------------------- CONSULTAS A LA API---------------------------
import { editarDevolucionesI, guardarDevolucionesI } from "../../../../../../API/Suministros/Devoluciones/DevolucionesInternasRequest";

// ------------------ COMPONENTES DE NECESARIOS--------------------------
import { Dialog } from "primereact/dialog";

        

const AgregarDevolucionInterna = ({
  selected,
  setSelected,
  SalidaDet,
  showDialogDI,
  setShowDialogDI,
  getInfo,
  actualizarScreen,
}) => {

  const toast = useRef(null);
  const [quantities, setQuantities] = useState({});
  const [comment, setComment] = useState({});
  const [loading, setLoading] = useState(false);
  const { userAuth } = useContext(AuthContext);
  const [errorIndices, setErrorIndices] = useState([]);



  const updateQuantity = (index, value) => {
    setQuantities(prevQuantities => ({
      ...prevQuantities,
      [index]: value
    }));
  };

  const updateComment = (index, value) => {
    setComment(prevComment => ({
      ...prevComment,
      [index]: value
    }));
  };
  

  useEffect(() => {
    const initialQuantities = {};
    selected.forEach((SalidaDet, index) => {
      initialQuantities[index] = SalidaDet?.CantidadDevolucion ? SalidaDet.CantidadDevolucion : "";
    });
    setQuantities(initialQuantities);
  }, [selected]);

  useEffect(() => {
    const initialComment = {};
    selected.forEach((SalidaDet, index) => {
      initialComment[index] = SalidaDet?.Comentarios ? SalidaDet.Comentarios : "";
    });
    setComment(initialComment);
  }, [selected]);

    //PARA ENCABEZADO  VALUES
    const initialValues = {
      IdDevolucionDetalle: -1,
    };

  const {
    values,
    handleInputChange,
    resetForm,
    error,
    setError,
  } = useForm(initialValues);


  const verificarInfo = () => {
    let error = {};
    selected.forEach((SalidaDet, index) => {
      if (!quantities[index]) {
        error[`CantidadDevolucion_${index}`] = true;
        toastShow(toast, "warn", "Advertencia", `Ingrese la cantidad a devolver de la Requisa ${SalidaDet.Requisa}.`);
        error.error = true;
      }
      if (!comment[index]) {
        error[`Comentario_${index}`] = true;
        toastShow(toast, "warn", "Advertencia", `Ingrese el comentario de la Salida de ${SalidaDet.Requisa}.`);
        error.error = true;
      }
    });
    setError(error);
    return error;
  };

  const agregarDevolucion = async () => {
    const e = verificarInfo();
    if (!e.error) {
      let hasError = false;
      const newErrorIndices = [];
      selected.forEach((detalle, index) => {

        if(quantities[index] > detalle?.BalanceDevolucion){
          toastShow( toast, "warn", "Cantidad Incorrecta",`No se puede devolver mas de la cantidad del Balance en la salida: ${detalle?.Requisa}.`);
          newErrorIndices.push(index); 
          hasError = true;
          
        }
      });

      setErrorIndices(newErrorIndices);

      if (!hasError) {
        setLoading(true)
        const detalles = selected.map((SalidaDet, index) => ({
          IdDevolucionDetalle: SalidaDet.IdDevolucionDetalle,
          IdSalidaDetalle: SalidaDet?.IdSalidaDetalle,
          CantidadDevolucion: quantities[index],
          Comentarios: comment[index],
          IdProducto: SalidaDet?.IdProducto,
          IdEstado: SalidaDet?.IdEstado,
          FechaDevolucion: new Date(),
          IdUserDevolucion: userAuth?.IdUser
        }));


        if(detalles.IdDevolucionDetalle > 0){
          const respuesta = await editarDevolucionesI(detalles)
          if (respuesta[0]?.ESTADO !== 1) {
            toastShow( toast, "error", "Cantidad Incorrecta", respuesta[0]?.MENSAJE );
            setLoading(false)
          } else {
            getInfo();
            actualizarScreen();
            toastShow(toast, "success", "Salida Editada", respuesta[0]?.MENSAJE);
            setTimeout(() => {
              setShowDialogDI(false);
            }, 700);
          }
        }else{
          const respuesta = await guardarDevolucionesI(detalles)
          if (respuesta[0]?.ESTADO !== 1) {
            toastShow( toast, "error", "Cantidad Incorrecta", respuesta[0]?.MENSAJE );
            setLoading(false)
          } else {
            getInfo();
            actualizarScreen();
            toastShow(toast, "success", "Salida Agregada", respuesta[0]?.MENSAJE);
            setTimeout(() => {
              setShowDialogDI(false);
            }, 700);
          }
        }
        setLoading(false)
      }
     
    }
  };

  const onHide = () => {
    setShowDialogDI(false);
    setSelected([]);
    getInfo();
    resetForm();
  };

  const DialogFooter = (
    <React.Fragment>
      <Button
        label="Cancelar"
        icon="pi pi-times"
        className="p-button-text"
        onClick={onHide}
      />
      <Button
        label={"Guardar"}
        icon="pi pi-check"
        className="p-button-text"
        onClick={() => {
          agregarDevolucion();
        }}
        loading={loading}
      />
    </React.Fragment>
  );

  const eliminarCard = (index) => {
    const newSelected = [...selected];
    newSelected.splice(index, 1);
    setSelected(newSelected);
  };



  return (
    <div>
      <Toast ref={toast} style={{ zIndex: 50000 }} />
      <Dialog
        visible={showDialogDI}
        modal
        className="modal__usuarios"
        footer={DialogFooter}
        onHide={onHide}
      >
        <div id="Dialog">
          <Loader loading={loading} querySelector={"#Dialog"}></Loader>
          {selected?.map((SalidaDet, index) => (
            <Card
              titulo={<h4> Devolución de {SalidaDet?.Requisa}</h4>}
              // style={{
              //   backgroundColor: error[`CantidadDevolucion_${index}`] || error[`Comentario_${index}`] ? '#f9e0e1' : 'transparent',
              //   padding: '1em',
              //   borderRadius: '8px',
              // }}
              contenido={
                <div 
                  id={`Dialog_${index}`}
                  className="mb-2"
                  style={{
                    backgroundColor: errorIndices.includes(index) ? '#fcf2f2' : 'transparent',
                    padding: '1em',
                    borderRadius: '8px',
                  }}
                >

                  {selected.length > 1 && (
                    <div className="d-flex justify-content-end">
                      <Button
                        icon="pi pi-times"
                        text
                        severity="danger"
                        aria-label="Cancel"
                        onClick={() => eliminarCard(index)}
                      />
                    </div>
                  )}

                  <Loader loading={loading} querySelector={"#Dialog"} />
                  <div style={{ width: "auto", height: "auto", margin: "auto" }} >
                    <div className="d-flex align-items-center">
                      <h2 className="me-3">{""}</h2>
                    </div>
                    <Toast ref={toast} style={{ zIndex: 50000 }} />

                    <div className="modal__input-contenedor d-flex justify-content-between">
                      <div className="d-flex gap-1">
                        <p className="fw-bold">Estante:</p>
                        <span>{SalidaDet?.NombreEstante}</span>
                      </div>

                      <div className="d-flex gap-1">
                        <p className="fw-bold">Posicion:</p>
                        <span>{SalidaDet?.NombrePosicion}</span>
                      </div>

                      <div className="d-flex gap-1">
                        <p className="fw-bold">Bandeja:</p>
                        <span>{SalidaDet?.NombreBandeja}</span>
                      </div>
                    </div>

                    <div className="modal__input-contenedor">
                      <div className="field col-6 me-2">
                        <span className="p-float-label">
                          <InputText
                            name="Producto"
                            value={SalidaDet?.NombreProducto}
                            onChange={handleInputChange}
                            disabled
                            style={{ width: "100%" }}
                            abelStyle={{
                              color: "gray",
                              textShadow: "0px 0px 1px white",
                            }}
                          />
                          <label htmlFor="Producto">Producto</label>
                        </span>
                      </div>

                      <div className="field col-6 me-2">
                        <span className="p-float-label">
                          <InputText
                            name="UserNameDespacho"
                            disabled
                            value={SalidaDet?.UserNameDespacho}
                            onChange={handleInputChange}
                            style={{ width: "100%" }}
                            abelStyle={{
                              color: "gray",
                              textShadow: "0px 0px 1px white",
                            }}
                            useGrouping={false}
                          />
                          <label htmlFor="UserNameDespacho">
                            Usuario Despachó
                          </label>
                        </span>
                      </div>
                    </div>

                    <div className="modal__input-contenedor">
                      <div className="field col-6 me-2">
                        <span className="p-float-label">
                          <InputText
                            name="Area"
                            disabled
                            value={SalidaDet?.Area}
                            onChange={handleInputChange}
                            style={{ width: "100%" }}
                            abelStyle={{
                              color: "gray",
                              textShadow: "0px 0px 1px white",
                            }}
                            useGrouping={false}
                          />
                          <label htmlFor="Area">Area</label>
                        </span>
                      </div>

                      <div className="field col-6 me-2">
                        <span className="p-float-label">
                          <InputText
                            name="FechaSalida"
                            disabled
                            value={SalidaDet?.FechaSalida}
                            onChange={handleInputChange}
                            style={{ width: "100%" }}
                            abelStyle={{
                              color: "gray",
                              textShadow: "0px 0px 1px white",
                            }}
                            readOnly
                          />
                          <label htmlFor="FechaSalida">Fecha de Salida</label>
                        </span>
                      </div>
                    </div>

                    
                    <div className="modal__input-contenedor">
                      <div className="field col-6 me-2">
                        <span className="p-float-label">
                          <InputText
                            name="Qty"
                            value={SalidaDet?.Qty}
                            onChange={handleInputChange}
                            disabled
                            style={{ width: "100%" }}
                            abelStyle={{
                              color: "gray",
                              textShadow: "0px 0px 1px white",
                            }}
                          />
                          <label htmlFor="Qty">Cantidad Solicitada</label>
                        </span>
                      </div>

                      <div className="field col-6 me-2">
                        <span className="p-float-label">
                          <InputText
                            name="QtySalida"
                            value={SalidaDet?.QtySalida}
                            onChange={handleInputChange}
                            disabled
                            style={{ width: "100%" }}
                            abelStyle={{
                              color: "gray",
                              textShadow: "0px 0px 1px white",
                            }}
                          />
                          <label htmlFor="QtySalida">Cantidad Despachada</label>
                        </span>
                      </div>
                    </div>

                    <div className="modal__input-contenedor">
                      <div className="field col-6 me-2">
                        <span className="p-float-label">
                          <InputText
                            name="BalanceDevolucion"
                            disabled
                            value={SalidaDet?.BalanceDevolucion}
                            onChange={handleInputChange}
                            style={{ width: "100%" }}
                            abelStyle={{
                              color: "gray",
                              textShadow: "0px 0px 1px white",
                            }}
                            readOnly
                          />
                          <label htmlFor="BalanceDevolucion">Balance de Devolución</label>
                        </span>
                      </div>

                      <div className="field col-6 me-2">
                        <span className="p-float-label">
                          <InputNumber
                            name={`CantidadDevolucion_${index}`}
                            value={quantities[index] || ""}
                            onChange={(e) => updateQuantity(index, e.value)}    
                            style={{ width: "100%" }}
                            useGrouping={false}
                            className={error[`CantidadDevolucion_${index}`] ? "p-invalid" : ""}
                            autoFocus={index === 0}
                          />
                          <label htmlFor="CantidadDevolucion">
                            Cantidad a Devolver
                          </label>
                        </span>
                      </div>
                    </div>

                    <div className="modal__input-contenedor">
                      <div className="field col-6 me-2">
                        <span className="p-float-label">
                          <InputText
                            name={`Comentario_${index}`}
                            value={comment[index] || ""}
                            onChange={(e) => updateComment(index, e.target.value)}
                            style={{ width: "100%" }}
                            className={error[`Comentario_${index}`] ? "p-invalid" : ""}
                          />
                          <label htmlFor="Comentario">Comentario</label>
                        </span>
                      </div>
                    </div>

                  </div>
                </div>
              }
            ></Card>
          ))}
        </div>
      </Dialog>
    </div>
  );
};

export default AgregarDevolucionInterna;
